import React from 'react'
import './style.scss'
import Modal from 'react-modal'
import IconMulher from '../../assets/images/mulher.png'

export default function ModalError({ codeErrorModalIsOpen }) { 

    return ( 
        <Modal
			id="codeErrorModal"
			isOpen={codeErrorModalIsOpen}
			className="error-modal-container"
			>
				<div className="error-modal-header-container">
					<div className="error-modal-image">
						<img alt="Icon Mulher" src={IconMulher} />
					</div>	
				</div>	
				<div className="error-modal-text-container">
                    <div className="error-modal-text-title">
						Ops! Verifique o link de indicação
					</div>
					<div className="error-modal-text">
					    Parece que tem algo de errado com esse link. 
                        Verifique a mensagem de indicação que recebeu do seu amigo e tente acessar o link novamente.
					</div>
				</div>	
		</Modal>
    )
}